import { Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { MAX_ITEMS_PER_MIRRORED_DECLARATION } from '../../constants';

type Props = {
    open: boolean;
    messageType: MessageTypes;
    itemCount: number;
    declarationsCount: number;
    onConfirm: () => void;
    onCancel: () => void;
};

const GenerateMultipleMirroredDeclarationsModal = ({
    open,
    messageType,
    itemCount,
    declarationsCount,
    onConfirm,
    onCancel,
}: Props) => (
    <ConfirmationModal
        open={open}
        type="warning"
        icon={<ExclamationCircleOutlined />}
        title={`Generate multiple ${messageType} declarations?`}
        confirmButtonText={`Generate ${declarationsCount} ${messageType}s`}
        cancelButtonText="Cancel"
        onConfirm={onConfirm}
        onCancel={onCancel}
        onClose={onCancel}
        content={
            <Typography>
                This declaration has {itemCount} items, more than the {MAX_ITEMS_PER_MIRRORED_DECLARATION} allowed in a
                single {messageType}. {declarationsCount} {messageType} declarations will be generated, each linked to
                this declaration.
            </Typography>
        }
    />
);

export default GenerateMultipleMirroredDeclarationsModal;
